import axios from "axios";
import httpcommon1 from "../Components/HttpCommon";
import httpcommon from "../Components/HttpCommonALL";

import { encryptData } from "./encryptDecrypt";
import { getResolvedWarehouseCode } from "./warehouseContext";

class authenticationServices {
  async getDocumentUrl(fileName) {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_UTILITY_SERVICE_URL}api/gcp/document-url`,
        { params: { fileName } },
      );

      if (response?.status === 200) {
        return response;
      } else {
        console.error("API Error:", response.statusText);
        return null;
      }
    } catch (error) {
      console.error("API Request Error:", error);
      return null;
    }
  }
  async loginApi(formData) {
    const encryptedData = encryptData(formData);

    try {
      const response = await httpcommon.post(
        "login/authenticate-email",
        encryptedData,
      );

      if (response?.status === 200) {
        return response;
      } else {
        console.error("API Error:", response.statusText);
        return null;
      }
    } catch (error) {
      console.error("API Request Error:", error);
      return null;
    }
  }
  async getEnquiryOrders(payload) {
    var queryString = Object.keys(payload)
      .map((key) => key + "=" + payload[key])
      .join("&");

    try {
      const response = await httpcommon.get(
        `order/list/enquiry?${queryString.toString()}`,
      );

      if (response?.status === 200) {
        return response;
      } else {
        console.error("API Error:", response.statusText);
        return null;
      }
    } catch (error) {
      console.error("API Request Error:", error);
      return null;
    }
  }
  async getmedicineOrders(payload) {
    const warehouseId = getResolvedWarehouseCode();
    if (warehouseId && payload.warehouseId == null) {
      payload = { ...payload, warehouseId };
    }
    var queryString = Object.keys(payload)
      .map((key) => key + "=" + payload[key])
      .join("&");

    try {
      const response = await httpcommon.get(
        `order/order-list?${queryString.toString()}`,
      );

      if (response?.status === 200) {
        return response;
      } else {
        console.error("API Error:", response.statusText);
        return null;
      }
    } catch (error) {
      console.error("API Request Error:", error);
      return null;
    }
  }
  async getEclinics(payload) {
    var queryString = Object.keys(payload)
      .map((key) => key + "=" + payload[key])
      .join("&");

    try {
      const response = await httpcommon.get(
        `hospital/alllist?${queryString.toString()}`,
      );

      if (response?.status === 200) {
        return response;
      } else {
        console.error("API Error:", response.statusText);
        return null;
      }
    } catch (error) {
      console.error("API Request Error:", error);
      return null;
    }
  }
  /* GET hospital/eclinics-with-orders -> only the eClinics that actually have
     orders in the queue, so the Allocation & Billing clinic filter lists those
     rather than every eClinic on record. Takes the same query params as
     order/order-list (procedureStatus, conStatus, state, circleCode, ...) so the
     dropdown stays consistent with the queue it filters. Same response envelope
     as getEclinics: data.successList[] of { code, name, ... }. */
  async getEclinicsWithOrders(payload) {
    var queryString = Object.keys(payload)
      .map((key) => key + "=" + payload[key])
      .join("&");

    try {
      const response = await httpcommon.get(
        `hospital/eclinics-with-orders?${queryString.toString()}`,
      );

      if (response?.status === 200) {
        return response;
      } else {
        console.error("API Error:", response.statusText);
        return null;
      }
    } catch (error) {
      console.error("API Request Error:", error);
      return null;
    }
  }
  async getEnquiryDetails(payload) {
    var queryString = Object.keys(payload)
      .map((key) => key + "=" + payload[key])
      .join("&");

    try {
      const response = await httpcommon.get(
        `enquiryDetails/alllist?${queryString.toString()}`,
      );

      if (response?.status === 200) {
        return response;
      } else {
        console.error("API Error:", response.statusText);
        return null;
      }
    } catch (error) {
      console.error("API Request Error:", error);
      return null;
    }
  }
  async getOrderDetails(payload) {
    var queryString = Object.keys(payload)
      .map((key) => key + "=" + payload[key])
      .join("&");

    try {
      const response = await httpcommon.get(
        `orderDetails/alllist?${queryString.toString()}`,
        payload,
      );

      if (response?.status === 200) {
        return response;
      } else {
        console.error("API Error:", response.statusText);
        return null;
      }
    } catch (error) {
      console.error("API Request Error:", error);
      return null;
    }
  }
  async getwareHouseDetails() {
    try {
      const response = await httpcommon.get(`warehouse/list`);

      if (response?.status === 200) {
        return response;
      } else {
        console.error("API Error:", response.statusText);
        return null;
      }
    } catch (error) {
      console.error("API Request Error:", error);
      return null;
    }
  }
  async updateEnquiryDetails(payload) {
    var queryString = Object.keys(payload)
      .map((key) => key + "=" + payload[key])
      .join("&");

    try {
      const response = await httpcommon.post(
        `enquiryDetails/enquiryDetailsSave`,
        payload,
      );

      if (response?.status === 200) {
        return response;
      } else {
        console.error("API Error:", response.statusText);
        return null;
      }
    } catch (error) {
      console.error("API Request Error:", error);
      return null;
    }
  }
  async submitEnquiryDetails(payload) {
    var queryString = Object.keys(payload)
      .map((key) => key + "=" + payload[key])
      .join("&");

    try {
      const response = await httpcommon.post(
        `enquiryDetails/enquiryDetailsUpdate`,
        payload,
      );

      if (response?.status === 200) {
        return response;
      } else {
        console.error("API Error:", response.statusText);
        return null;
      }
    } catch (error) {
      console.error("API Request Error:", error);
      return null;
    }
  }
  async submitorderDetails(payload) {
    var queryString = Object.keys(payload)
      .map((key) => key + "=" + payload[key])
      .join("&");

    try {
      const response = await httpcommon.post(
        `order/updateProcedureStatus`,
        payload,
      );

      if (response?.status === 200) {
        return response;
      } else {
        console.error("API Error:", response.statusText);
        return null;
      }
    } catch (error) {
      console.error("API Request Error:", error);
      return null;
    }
  }

  async transferOrder(payload) {
    try {
      const response = await httpcommon.post(
        `order/updateWarehouseDetails`,
        payload,
      );

      if (response?.status === 200) {
        return response;
      } else {
        console.error("API Error:", response.statusText);
        return null;
      }
    } catch (error) {
      console.error("API Request Error:", error);
      return null;
    }
  }
  async updateOrderDetails(payload) {
    var queryString = Object.keys(payload)
      .map((key) => key + "=" + payload[key])
      .join("&");

    try {
      const response = await httpcommon.post(
        `orderDetails/updateOrderDetails`,
        payload,
      );

      if (response?.status === 200) {
        return response;
      } else {
        console.error("API Error:", response.statusText);
        return null;
      }
    } catch (error) {
      console.error("API Request Error:", error);
      return null;
    }
  }
  async bulkOrderEnquiry(payload) {
    var queryString = Object.keys(payload)
      .map((key) => key + "=" + payload[key])
      .join("&");

    try {
      const response = await httpcommon.put(
        `enquiryDetails/bulk-order?${queryString.toString()}`,
      );

      if (response?.status === 200) {
        return response;
      } else {
        console.error("API Error:", response.statusText);
        return null;
      }
    } catch (error) {
      console.error("API Request Error:", error);
      return null;
    }
  }
  async getShipmentList(payload) {
    try {
      const response = await httpcommon.post(`shipments/filter`, payload);

      if (response?.status === 200) {
        return response;
      } else {
        console.error("API Error:", response.statusText);
        return null;
      }
    } catch (error) {
      console.error("API Request Error:", error);
      return null;
    }
  }

  async getB2BShipmentList(payload) {
    try {
      const response = await httpcommon.post(`b2bs/shipments/filter`, payload);

      if (response?.status === 200) {
        return response;
      } else {
        console.error("API Error:", response.statusText);
        return null;
      }
    } catch (error) {
      console.error("API Request Error:", error);
      return null;
    }
  }

  async getShipmentOrderDetails(shipmentPackageNo) {
    try {
      const response = await httpcommon.get(`shipments/${shipmentPackageNo}`);

      if (response?.status === 200) {
        return response;
      } else {
        console.error("API Error:", response.statusText);
        return null;
      }
    } catch (error) {
      console.error("API Request Error:", error);
      return null;
    }
  }

  async getB2BShipmentOrderDetails(shipmentPackageNo) {
    try {
      const response = await httpcommon.get(
        `b2bs/shipments/${shipmentPackageNo}`,
      );

      if (response?.status === 200) {
        return response;
      } else {
        console.error("API Error:", response.statusText);
        return null;
      }
    } catch (error) {
      console.error("API Request Error:", error);
      return null;
    }
  }
  async getShipmentDetails(consignmentId) {
    try {
      const response = await httpcommon.get(
        `print-slip/details/${consignmentId}`,
      );

      if (response?.status === 200) {
        return response;
      } else {
        console.error("API Error:", response.statusText);
        return null;
      }
    } catch (error) {
      console.error("API Request Error:", error);
      return null;
    }
  }
  async getB2BShipmentDetails(consignmentId) {
    try {
      const response = await httpcommon.get(
        `print-slip/details-b2b/${consignmentId}`,
      );

      if (response?.status === 200) {
        return response;
      } else {
        console.error("API Error:", response.statusText);
        return null;
      }
    } catch (error) {
      console.error("API Request Error:", error);
      return null;
    }
  }
  async getDrugMasterDetails(drugCode) {
    try {
      const mdmToken = process.env.REACT_APP_MDM_API_TOKEN;
      const response = await axios.get(
        `${process.env.REACT_APP_API_MDM_URL}cureBayDrugMaster/${drugCode}`,
        {
          headers: {
            "Content-type": "application/json",
            Authorization: `JWT ${mdmToken}`,
          },
        },
      );

      if (response?.status === 200) {
        return response;
      } else {
        console.error("API Error:", response.statusText);
        return null;
      }
    } catch (error) {
      console.error("API Request Error:", error);
      if (error.response?.status === 401) {
        return { error: true, status: 401 };
      }
      return null;
    }
  }
  async updateDrugMasterMedicineId(drugCode, medicineId) {
    try {
      const mdmToken = process.env.REACT_APP_MDM_API_TOKEN;
      const response = await axios.put(
        `${process.env.REACT_APP_API_MDM_URL}cureBayDrugMaster/${drugCode}`,
        { medicineId },
        {
          headers: {
            "Content-type": "application/json",
            Authorization: `JWT ${mdmToken}`,
          },
        },
      );

      try {
        await axios.put(
          `${process.env.REACT_APP_MEDS_URL}master-medicine/update-cb-medicine-id?medicineId=${medicineId}&curebayDrugCode=${drugCode}`,
          null,
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
        );
      } catch (medsError) {
        console.error("Meds API Request Error:", medsError);
        if (medsError.response?.status === 404) {
          return { medsError: true, medsStatus: 404 };
        }
      }

      if (response?.status === 200) {
        return response;
      } else {
        console.error("API Error:", response.statusText);
        return null;
      }
    } catch (error) {
      console.error("API Request Error:", error);
      if (error.response?.status === 401) {
        return { error: true, status: 401 };
      }
      return null;
    }
  }
  async getEnquiryAnalytics(hospitalId, fromDate, toDate) {
    try {
      const response = await httpcommon.get(
        `enquiry/analytics?hospitalId=${hospitalId}&fromDate=${fromDate}&toDate=${toDate}`,
      );
      if (response?.status === 200) {
        return response;
      } else {
        return null;
      }
    } catch (error) {
      console.error("API Request Error:", error);
      return null;
    }
  }
}

const apiService = new authenticationServices();
export default apiService;
